let poppedState = false;

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    poppedState = true;
  });
}

/**
 * Whether the current location came from the browser's back or forward button. React Router reports the page load and
 * a reload as `POP` too; only a real back or forward fires `popstate`, or loads the whole document as `back_forward`.
 */
export function isBrowserBackForward(history: { action: string }): boolean {
  if (history.action !== 'POP') return false;
  if (poppedState) return true;
  const [entry] = (performance.getEntriesByType?.('navigation') ?? []) as PerformanceNavigationTiming[];
  return entry?.type === 'back_forward';
}
